/* eslint-disable */
import React, { useEffect, useState } from "react";
import SearchBar from "./components/SearchBar";
import API_USERS from "../../services/users";
import ListItem from "./components/ListItem";
import Fuse from "fuse.js";

import * as Styles from "./styles";
import SkeletonLoading from "./components/SkeletonLoading";

interface PermissoesProps {
  idPermissao: string;
  chave: string;
}

interface LocaisProps {
  idLocal: string;
  nome: string;
}

interface EmpreendimentosProps {
  idEmpreendimnto: string;
  nome: string;
}

interface UserData {
  acessoAdmin: boolean;
  acessoMobile: boolean;
  ativo: true;
  celular: string | null;
  email: string;
  id: string;
  idCorretor: string;
  idPerfilCorretor: string;
  idRegional: string;
  nome: string;
  nomeFotoUsuario: string;
  nomePerfilAcesso: string;
  nomeRegional: string;
  siglaNome: string;
  empreendimentos: EmpreendimentosProps[];
  locais: LocaisProps[];
  permissoes: PermissoesProps[];
}

const logUsers: React.FC = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState(data);
  const [dataApplied, setDataApplied] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchUser, setSearchUser] = useState("");

  useEffect(() => {
    requestUsers();
  }, []);

  const requestUsers = async () => {
    setLoading(true);
    try {
      const response = await API_USERS.GetUsers();
      const { data: users } = response?.data;
      setData(users);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Styles.Container>
      <Styles.Card>
        <SearchBar value={searchUser} onChange={(val) => setSearchUser(val)} />
        {loading ? (
          <SkeletonLoading />
        ) : (
          data
            .filter((val: any) => {
              if (searchUser === "") {
                return val;
              } else if (
                val.nome
                  .toLowerCase()
                  .trim()
                  .includes(searchUser.toLowerCase().trim())
              ) {
                return val;
              }
            })
            .map((item, key) => {
              return <ListItem data={item} key={key} />;
            })
        )}
      </Styles.Card>
    </Styles.Container>
  );
};

export default logUsers;
